import React, {Component} from "react"
import {Badge} from "react-bootstrap"

const styleMap = {
  NOT_STARTED: 'scheduled',
  IN_PROGRESS: 'inprogress',
  COMPLETED: 'completed',
}

const textMap = {
  NOT_STARTED: 'Scheduled',
  IN_PROGRESS: 'In Progress',
  COMPLETED: 'Completed',
}

class CogoLandSessionStatusLabel extends Component {
  render() {

    const style = styleMap[this.props.status]

    return (
      <Badge pill bsStyle={style}>{this.props.text?this.props.text:textMap[status]}</Badge>
    )
  }
}

export default CogoLandSessionStatusLabel



// WEBPACK FOOTER //
// ./src/routes/cogoland/component/CogoLandSessionStatusLabel.js